import axios from "axios";
import router from "@/router";
import qs from "qs";

// DEFAULT CONFIG
const config = {
  baseURL: process.env.VUE_APP_API,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
    Accept: "application/json",
  },
  paramsSerializer: (params) => qs.stringify(params),
};

// INSTANCE
const $axios = axios.create(config);

// SET TOKEN
// Allows to set the token of axios instance after login
const setToken = (token) => {
  $axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

if (localStorage.getItem("token")) {
  setToken(localStorage.getItem("token"));
}

// INTERCEPTORS
$axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Logout if user is no longer authenticated
    // or the token is expired!
    if (error.response && error.response.status === 401) {
      router.replace("/logout");
    }
    //If status is not provided, axios is not sure what happend!
    if (!error.response && !error.status) {
      return Promise.reject(error);
    } else {
      return Promise.reject(error.response);
    }
  }
);

export default $axios;
export { setToken };
